// extracted by mini-css-extract-plugin
export default {"ellipsis":"iNjgvvxTkZKqq1MZWlxz","wrapper":"AFz9pGa_jXtR96fUNTK8","preFillInWhite":"Ucph1F8Q5EGRUHffzs6w","spin":"GYF3FuPOYTf5MWQmwDeQ"};